import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconCustom0763EnterRight({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="currentColor" fillRule="nonzero">
        <path d="M15.5 4v12c0 .827-.673 1.5-1.5 1.5H5.5c-.827 0-1.5-.673-1.5-1.5v-4a.5.5 0 011 0v4a.5.5 0 00.5.5H14a.5.5 0 00.5-.5V4a.5.5 0 00-.5-.5H5.5A.5.5 0 005 4v4a.5.5 0 01-1 0V4c0-.827.673-1.5 1.5-1.5H14c.827 0 1.5.673 1.5 1.5z" />
        <path d="M13.217 10.353a.5.5 0 000-.707l-2-2a.5.5 0 00-.707.707L11.656 9.5H2.5a.5.5 0 000 1h9.156l-1.146 1.147a.497.497 0 000 .706.5.5 0 00.707 0l2-2z" />
      </g>
    </svg>
  );
}
export default SvgIconCustom0763EnterRight;
